module.exports = __webpack_public_path__ + "img/component-icon.e2fcf43e.png";